import React from 'react';
// import clsx from 'clsx';
import { ScrollingCarousel } from '@trendyol-js/react-carousel';
import ViewAll from 'components/shared/ViewAll';
import ContentSection from 'components/shared/ContentSection';
import Skeleton from 'components/shared/Skeleton';
import clsx from 'clsx';
import { Link } from 'react-router-dom';
import useHashtags from 'sdk/hooks/useHashtags';
import styles from './HashtagCollection.module.scss';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function HashtagCollection({ collectionId }: {
  collectionId: number,
}) {
  const collectionData = useHashtags(0, 100)

  if (collectionData.isFetching) {
    return (
      <ContentSection
        skeleton
      >
        <ScrollingCarousel className={styles.topics}>
          {Array.from(Array(6).keys()).map((item) => (
            <Skeleton className={clsx(styles.listItem, styles.listItemSkeleton)} key={item} />
          ))}
        </ScrollingCarousel>
      </ContentSection>
    )
  }

  if (!collectionData?.data?.items?.length) {
    return null
  }

  return (
    <ContentSection
      title="Trending Tags"
      headerRight={(<ViewAll url="/hashtags" />)}
    >
      <ScrollingCarousel className={styles.topics}>
        {(collectionData?.data?.items || []).map((item: any) => (
          <Link
            to={`/hashtags/${item?.id}`}
            key={item?.id}
            className={styles.listItem}
            style={{ background: item?.color }}
          >
            {item.label}
          </Link>
        ))}
      </ScrollingCarousel>
    </ContentSection>
  )
}

export default HashtagCollection
